<template>
  <div class="default-layout flex flex-col min-h-screen">
    <NavBar class="fixed top-0 left-0 right-0 z-50" />
    <main :class="['flex-grow', 'pt-16', { 'snap-y snap-mandatory': isHomePage }]">
      <slot></slot>
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import NavBar from '@/components/App/NavBar.vue'
import Footer from '@/components/App/Footer.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()

const isHomePage = computed(() => route.name === 'Home')
</script>

<style scoped>
/* Styles spécifiques au layout */
</style>
